module.exports = __webpack_public_path__ + "img/borchia_3.2b77b9c9.svg";